<template>
	<div class="data-table-container customize-table">
		<v3-table :headers="headers" :items="itemsToDisplay" alternating :rows-per-page="rowsPerPage" hide-rows-per-page
			hide-footer>
			<template #item-customerName="{ id, name, pictureUrl }">
				<div class="d-flex">
					<div>
						<v-avatar color="grey" size="40" class="ml-2 mr-2" :image="pictureUrl">
						</v-avatar>
					</div>
					<div class="my-auto mx-2 cursor-pointer" @click="getCustomer(id)">
						{{ name }}
					</div>
				</div>
			</template>
			<template #header-customerName="header">
				<div class="text-left cursor-pointer">
					{{ $t('name') }}
				</div>
			</template>

			<template #header-CustomerEmail="header">
				<div class="text-left cursor-pointer">
					{{ $t('email') }}
				</div>
			</template>
			<template #header-customerPhone="header">
				<div class="text-left cursor-pointer">
					{{ $t('phone') }}
				</div>
			</template>
			<template #header-incidentCount="header">
				<div class="text-left cursor-pointer">
					{{ $t('incident_history') }}
				</div>
			</template>

			<template #item-incidentCount="{ incidentCount }">
				<div style="color: rgba(255, 126, 135, 1); font-weight: 600">
					{{ incidentCount }} incidents
				</div>
			</template>
			<template #item-CustomerEmail="{ email }">
				<div class="d-flex">
					{{ email }}
				</div>
			</template>
			<template #item-customerPhone="{ phone }">
				<div class="d-flex">
					{{ phone }}
				</div>
			</template>
			<template #item-button="{ id, name }">
				<v-menu>
					<template v-slot:activator="{ props }">
						<div v-bind="props">
							<v-icon>mdi-dots-vertical</v-icon>
						</div>
					</template>

					<v-list class="mt-2" rounded="xl" style="cursor: pointer" elevation="1">
						<v-list-item>
							<v-list-item-title>
								<div class="d-flex mx-3 mb-2 mt-1" @click="editCustomer(id)">
									<div><v-icon>mdi-pencil</v-icon></div>
									<div class="ml-2">{{ $t('edit') }}</div>
								</div>
							</v-list-item-title>
							<v-list-item-title>
								<div class="d-flex mx-3 mt-1 mb-1" style="color: rgba(255, 126, 135, 1)"
									@click="deleteCustomer(id, name)">
									<div>
										<v-icon>mdi-trash-can-outline</v-icon>
									</div>
									<div class="ml-2">{{ $t('delete') }}</div>
								</div>
							</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</template>
		</v3-table>

		<v-row class="mt-4 ml-4">
			<v-col cols="4" md="8" class="d-flex align-center">
				{{ $t('total') }}: {{ items.length }} {{ $t('customer') }}
			</v-col>

			<v-col cols="8" md="4">
				<v-pagination size="small" :length="Math.ceil(items.length / rowsPerPage)"
					class="custom-pagination mb-2" :model-value="currentPage" @update:model-value="updateCurrentPage">
					<template #next="{ disabled }">
						<v-btn icon size="small" rounded="xl" class="ml-2" variant="flat" :disabled="disabled" @click="
							(currentPage += 1),
							updateCurrentPage(currentPage)
							">
							<v-icon> mdi-chevron-right </v-icon>
						</v-btn>
					</template>

					<template #prev="{ disabled }">
						<v-btn icon size="small" rounded="xl" class="mr-2" variant="flat" :disabled="disabled" @click="
							(currentPage -= 1),
							updateCurrentPage(currentPage)
							">
							<v-icon> mdi-chevron-left </v-icon>
						</v-btn>
					</template>
				</v-pagination>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'

export default {
	created() {

	},
	name: 'DataTable',
	components: {
		'v3-table': Vue3EasyDataTable,
	},
	emits: ['singleCustomerInformation', 'openCustomeEditor'],
	props: {
		headers: Array,
		items: Array,
		rowsPerPage: {
			type: Number,
			default: 10,
		},
	},
	methods: {
		updateCurrentPage(page) {
			this.currentPage = page
		},
		getCustomer(id) {
			this.$emit('singleCustomerInformation', id)
		},
		editCustomer(id) {
			this.$emit('openCustomerEditor', id)
		},
		deleteCustomer(id, name) {
			this.$emit('openDeleteCustomer', { id: id, name: name })
		},
	},
	data: () => ({
		openCreateDialog: false,
		currentPage: 1,
		colorCode: {
			low: 'gray',
			normal: 'green',
			high: 'yellow',
			urgent: 'red',
		},
		agentDetials: {},
		itemSelected: [],
	}),
	computed: {
		itemsToDisplay() {
			// Reverse the array to display the latest items at the top
			const reversedItems = [...this.items].reverse()

			const startIndex = (this.currentPage - 1) * this.rowsPerPage
			const endIndex = startIndex + this.rowsPerPage

			// Slice the reversed array
			return reversedItems.slice(startIndex, endIndex)
		},
	},
}
</script>
<style scoped>
.customize-table {
	--easy-table-border: 1px solid var(--primary-color-lighten);
	--easy-table-row-border: 1px solid var(--primary-color-lighten);
	--easy-table-header-font-size: 18px;
	--easy-table-header-height: 50px;
	--easy-table-header-background-color: var(--secondary-color);
	--easy-table-header-item-padding: 15px 20px;
	/* --easy-table-header-font-color: white; */

	--easy-table-body-row-background-color: var(--secondary-color-lighten);
	--easy-table-body-row-height: 50px;
	--easy-table-body-row-font-size: 16px;
	--easy-table-body-row-hover-background-color: var(--primary-color-lighten);

	--easy-table-body-item-padding: 10px 15px;
	--easy-table-footer-background-color: var(--gray-1);
	--easy-table-footer-font-size: 14px;
	--easy-table-footer-padding: 0px 10px;
	--easy-table-footer-height: 50px;

	--easy-table-loading-mask-background-color: #000000;
	font-family: 'Roboto';
}
</style>
